<template>
  <footer class="footer">
    <div class="footer__inner">
      <div class="footer__body">
        <div class="footer__contacts">
          <div class="footer__header">
            <AppLogo 
              :footer="true"
              class="footer__logo" 
            />
            <BurgerMenu v-if="isMobile" :nav-footer-list="navFooterList" is-footer />
          </div>
          <address class="footer__address">
            <p v-if="contacts.address">
              {{ contacts.address }}
            </p>

            <a v-if="contacts.phone"
              :href="'tel:' + contacts.phone.replaceAll(' ', '')"
              class="footer__phone">
              <span class="footer__phone-label">Телефон:</span>{{
                contacts.phone
              }}</a>

            <a v-if="contacts.email"
              :href="'mailto:' + contacts.email.replaceAll(' ', '')"
              class="footer__email">
              <span class="footer__email-label">E-mail:</span>{{
                contacts.email
              }}</a>
          </address>
          <SocialsList :socials-list="socialsList"
            class="footer__socials-list" />
        </div>
        <div class="footer__links">
          <FooterNav :nav-footer-list="navFooterList"
            class="footer__nav" />
          <ul class="footer__label-list">
            <li v-for="item in labelList"
              :key="item.name"
              class="footer__label-item">
              <app-svg :id="item.name" viewBox="0 0 123 51" />
            </li>
            <li>
              <a href="https://realty.ya.ru/sankt-peterburg_i_leningradskaya_oblast/agentstva/kvs-1056895011/"
                target="_blank"
                style="pointer-events:none;">
                <svg width="226"
                  height="64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 226 64"
                >
                  <path
                    d="M0 14.08C0 6.304 6.318 0 14.111 0h197.556c7.793 0 14.111 6.304 14.111 14.08v35.84c0 7.776-6.318 14.08-14.111 14.08H14.111C6.318 64 0 57.696 0 49.92V14.08Z"
                    fill="rgba(0, 0, 0, 0.12)" />
                  <path
                    d="M1.283 14.08c0-7.07 5.743-12.8 12.828-12.8h197.556c7.084 0 12.828 5.73 12.828 12.8v35.84c0 7.07-5.744 12.8-12.828 12.8H14.111c-7.085 0-12.828-5.73-12.828-12.8V14.08Z"
                    fill="#fff" />
                  <path
                    d="M44.603 11.024h7.9v10.074h-1.718V12.5h-4.478v8.6h-1.704V11.023ZM59.118 19.82a2.446 2.446 0 0 1-.31.506 2.177 2.177 0 0 1-.464.463 2.321 2.321 0 0 1-.648.323c-.253.085-.55.127-.887.127-.32 0-.615-.047-.887-.14a1.986 1.986 0 0 1-.718-.394 2.03 2.03 0 0 1-.479-.66 2.402 2.402 0 0 1-.169-.928c0-.796.296-1.39.887-1.784.592-.403 1.427-.604 2.507-.604h1.112v-.45c0-.478-.122-.806-.366-.983-.244-.188-.648-.281-1.211-.281-.479 0-.93.07-1.352.21-.413.131-.779.286-1.098.464v-1.363c.29-.16.676-.31 1.155-.45.478-.14 1-.21 1.562-.21.939 0 1.662.196 2.169.59.516.384.774 1.002.774 1.854v4.103c.01.103.014.21.014.323l.028.323c.01.094.02.174.029.24h-1.507a6.445 6.445 0 0 1-.085-.549 21.677 21.677 0 0 1-.042-.632l-.014-.098Zm-1.858.154c.347 0 .633-.07.858-.21.235-.15.423-.319.564-.506.14-.197.239-.389.295-.576.057-.188.085-.319.085-.394v-.491h-1.014c-.648 0-1.122.102-1.422.309a.949.949 0 0 0-.45.843c0 .318.089.571.267.758.188.178.46.267.817.267ZM66.906 21.239c-.554 0-1.032-.122-1.436-.366a2.916 2.916 0 0 1-.957-1.011v3.723h-1.634v-9.779h1.493l.112 1.293c.245-.44.568-.787.972-1.04.404-.262.896-.393 1.478-.393.432 0 .84.08 1.225.239.395.15.737.384 1.028.702.291.31.521.703.69 1.18.178.469.268 1.021.268 1.658 0 .646-.09 1.209-.268 1.686a3.35 3.35 0 0 1-.704 1.18c-.29.31-.633.544-1.028.703-.394.15-.807.225-1.239.225Zm-.394-1.363c.582 0 1.051-.197 1.408-.59.366-.403.55-1.017.55-1.84 0-.816-.184-1.425-.55-1.827-.357-.403-.821-.604-1.394-.604-.29 0-.558.051-.802.154a1.69 1.69 0 0 0-.648.45c-.178.206-.32.463-.423.772a3.24 3.24 0 0 0-.154 1.054c0 .412.051.773.154 1.082.104.3.244.553.423.759.178.197.39.346.633.45.254.093.521.14.803.14ZM75.08 15.127v5.971h-1.634v-5.971h-2.21v-1.32h6.096v1.32H75.08ZM83.717 18.021h-3.083v3.077H79v-7.292h1.634v2.895h3.083v-2.895h1.633v7.292h-1.633v-3.077ZM92.138 12.64a.917.917 0 0 1-.944-.927.917.917 0 0 1 .943-.927c.273 0 .498.088.677.266a.896.896 0 0 1 .267.66c0 .254-.089.474-.267.661a.917.917 0 0 1-.676.267Zm-2.873 0a.9.9 0 0 1-.661-.267.927.927 0 0 1-.268-.66c0-.263.09-.483.268-.66a.9.9 0 0 1 .662-.268c.272 0 .497.09.675.267a.873.873 0 0 1 .282.66.903.903 0 0 1-.282.661.917.917 0 0 1-.675.267Zm4.45 7.924c-.103.066-.23.14-.38.225-.15.075-.329.145-.535.211a5.43 5.43 0 0 1-1.648.239c-1.342 0-2.347-.333-3.013-.998-.657-.665-.986-1.597-.986-2.796 0-.59.09-1.12.268-1.588.178-.468.427-.861.746-1.18.32-.328.7-.576 1.14-.744a3.841 3.841 0 0 1 1.451-.267c.544 0 1.032.089 1.464.267.442.178.803.444 1.085.8.281.356.474.797.577 1.321.112.525.117 1.138.014 1.84h-5.055c.066.666.286 1.167.662 1.504.375.328.962.492 1.76.492.582 0 1.065-.07 1.45-.21.394-.15.728-.305 1-.464v1.348Zm-2.957-5.606c-.479 0-.882.146-1.21.436-.33.29-.545.721-.649 1.292h3.436c.019-.59-.113-1.025-.394-1.306-.282-.281-.676-.422-1.183-.422ZM99.863 21.239c-.553 0-1.032-.122-1.436-.366a2.916 2.916 0 0 1-.957-1.011v3.723h-1.633v-9.779h1.492l.113 1.293c.244-.44.568-.787.971-1.04.404-.262.897-.393 1.478-.393.432 0 .841.08 1.225.239.395.15.737.384 1.028.702.291.31.521.703.69 1.18.179.469.268 1.021.268 1.658 0 .646-.089 1.209-.268 1.686a3.343 3.343 0 0 1-.704 1.18c-.291.31-.633.544-1.028.703-.394.15-.807.225-1.239.225Zm-.394-1.363c.582 0 1.051-.197 1.408-.59.366-.403.549-1.017.549-1.84 0-.816-.183-1.425-.549-1.827-.357-.403-.821-.604-1.394-.604-.29 0-.558.051-.802.154a1.69 1.69 0 0 0-.648.45c-.178.206-.32.463-.422.772a3.24 3.24 0 0 0-.155 1.054c0 .412.051.773.154 1.082.104.3.245.553.423.759.178.197.39.346.633.45.254.093.522.14.803.14Z"
                    fill="#000" />
                  <circle cx="24.32"
                    cy="39.68"
                    fill="#F33"
                    r="12.8" />
                  <path
                    d="M26.233 34.048h-1.298c-2.225 0-3.337 1.11-3.337 2.776 0 1.85.742 2.776 2.41 3.886l1.298.926-3.708 5.737H18.63l3.523-5.182c-2.04-1.48-3.152-2.776-3.152-5.182 0-2.96 2.04-4.996 5.933-4.996h3.894v15.36h-2.596V34.048Z"
                    fill="#fff" />
                  <path
                    d="M44.634 30.005V49.28h3.362v-8.375h6.28v8.375h3.362V30.005h-3.362v8.293h-6.28v-8.293h-3.362ZM71.123 48.337v-2.69c-1.028.693-2.75 1.303-4.362 1.303-2.417 0-3.334-1.137-3.473-3.466h7.974v-1.747c0-4.854-2.14-6.684-5.445-6.684-4.03 0-5.946 3.078-5.946 7.294 0 4.853 2.389 7.21 6.612 7.21 2.112 0 3.668-.554 4.64-1.22ZM65.761 37.66c1.64 0 2.14 1.359 2.14 3.106v.277h-4.613c.083-2.218.89-3.383 2.473-3.383ZM85.786 46.673h-1.473V35.33h-9.641v1.193c0 3.41-.223 7.82-1.39 10.15h-1.028v5.796h3.057V49.28h7.418v3.19h3.057v-5.797Zm-4.78 0H76.34c.917-2.108 1.167-5.907 1.167-8.32v-.416h3.5v8.736ZM93.034 49.28c3.279 0 5.224-1.387 5.224-4.049 0-1.83-1.111-2.884-2.973-3.217 1.5-.416 2.445-1.47 2.445-3.134 0-2.385-1.584-3.55-4.64-3.55h-5.557v13.95h5.501Zm-.416-11.454c1.194 0 1.861.5 1.861 1.553 0 .97-.722 1.553-1.973 1.553H90.84v-3.106h1.779Zm.055 5.52c1.417 0 2.167.498 2.167 1.663 0 1.276-.833 1.775-2.167 1.775H90.84v-3.439h1.834ZM100.476 35.33v13.95h2.862l5.112-8.625v8.625h3.223V35.33h-2.862l-5.112 8.625V35.33h-3.223ZM116.839 49.28l4.39-6.85v6.85h3.307v-6.85l4.39 6.85h3.751l-4.863-7.543 4.224-6.407h-3.335l-4.167 6.434V35.33h-3.307v6.434l-4.168-6.434h-3.417l4.307 6.545-4.752 7.405h3.64ZM133.932 35.33v13.95h2.862l5.112-8.625v8.625h3.223V35.33h-2.862l-5.112 8.625V35.33h-3.223ZM159.825 49.28h3.224l-.056-13.95h-4.529l-3.029 9.29-2.723-9.29h-4.806v13.95h2.806V38.852l3.029 10.428h2.695l3.389-10.428V49.28ZM171.427 35.053c-3.64 0-6.169 2.579-6.169 7.266 0 4.66 2.529 7.238 6.169 7.238 3.639 0 6.168-2.579 6.168-7.266 0-4.659-2.529-7.238-6.168-7.238Zm0 11.897c-1.834 0-2.751-1.414-2.751-4.631 0-3.245.917-4.66 2.751-4.66 1.833 0 2.75 1.415 2.75 4.632 0 3.245-.917 4.66-2.75 4.66ZM185.817 49.557c1.528 0 2.611-.277 3.417-.86v-2.69c-.833.583-1.834.943-3.223.943-2.362 0-3.334-1.83-3.334-4.714 0-3.023 1.195-4.576 3.362-4.576 1.278 0 2.528.444 3.195.86v-2.802c-.694-.388-1.917-.665-3.556-.665-4.224 0-6.419 3.023-6.419 7.266 0 4.66 2.14 7.238 6.558 7.238ZM201.573 37.937V35.33h-11.087v2.607h3.89V49.28h3.307V37.937h3.89ZM203.53 35.33v13.95h4.974c3.278 0 5.612-1.664 5.612-4.937 0-3.106-2.084-4.742-5.557-4.742h-1.723v-4.27h-3.306Zm4.779 11.343h-1.473v-4.465h1.556c1.445 0 2.307.638 2.307 2.246 0 1.609-.945 2.22-2.39 2.22Z"
                    fill="#000" />
                </svg>
              </a>
            </li>
            <!-- <li>
              <iframe 
                src="https://yandex.ru/sprav/widget/rating-badge/244570313541?type=rating&theme=dark" 
                width="150" height="50" frameborder="0"
              ></iframe>
            </li> -->
          </ul>
          <TheBasement class="footer__basement" />
        </div>

      </div>
    </div>
    <teleport v-if="isPopupSuccessfully"
      to="body">
      <PopupSuccessfully @popup-close="isPopupSuccessfully = false" />
    </teleport>
    <teleport to="body">
      <AppModal v-if="reach" v-model="socModal" square >
        <SocialsModal :reach="reach" />
      </AppModal>
      <div class="open-modal-popup excursion social" @click="socModal = true">
        <SocialsModalIcon :reach="reach" />
      </div>


      <AppModal v-model="isOpenCallPopupModal">
        <ModalPopupForm @form-success-popup="formSuccessPopup" />
      </AppModal>
      <div class="open-modal-popup excursion" @click="isOpenCallPopupModal = true">
        <svg width="100%" height="100%" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="48" cy="48" r="48" fill="#FF6F02"/>
        <path d="M63.3886 20C64.1641 20.1867 64.9602 20.2421 65.7298 20.4681C69.961 21.7048 71.77 25.3099 72 29.4531L71.9823 65.1991C71.7656 67.3429 70.2898 68.304 68.2553 68.5578C68.211 71.4191 68.8686 75.2444 65.1533 75.9823H63.7188C62.4244 75.6965 61.5103 75.0344 61.0179 73.7933C60.8852 73.4579 60.6302 72.6397 60.6302 72.3189V68.5461H34.3639V72.3189C34.3639 72.6397 34.1089 73.4579 33.9762 73.7933C33.4838 75.0344 32.5697 75.6965 31.2753 75.9823C30.8182 75.9415 30.2845 76.0377 29.8408 75.9823C26.2332 75.5273 26.7138 71.1493 26.7447 68.5519C24.6306 68.4965 23.23 67.1577 23.0118 65.0883L23 29.5669C23.1474 24.082 27.7767 20.4229 33.04 20H63.3886ZM35.107 25.6016C34.0425 25.8145 34.072 27.3472 35.1896 27.4377H59.8046C61.0503 27.2918 60.8882 25.6366 59.694 25.5739L35.107 25.6016ZM30.258 31.1857C28.0716 31.3344 26.9217 32.857 26.7506 34.9278C26.4513 38.5694 26.9585 42.6018 26.7624 46.2841C26.9438 48.1946 28.1011 49.685 30.1106 49.8557H64.8806C67.0065 49.6748 68.096 48.0779 68.2464 46.0843C68.012 42.4326 68.5457 38.4294 68.2405 34.8199C68.0518 32.5945 66.7264 31.2148 64.4398 31.1507L30.2565 31.1871L30.258 31.1857ZM30.258 57.3152C24.9387 57.8023 26.1653 65.8248 31.4124 64.6931C35.8707 63.732 34.8136 56.8981 30.258 57.3152ZM64.1375 57.3152C59.2989 57.7586 59.778 64.9016 64.5341 64.8185C69.6072 64.7296 69.2077 56.85 64.1375 57.3152Z" fill="white"/>
        </svg>
      </div>
    </teleport>
  </footer>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import BurgerMenu from './BurgerMenu.vue'
import TheBasement from "@/components/TheBasement.vue";
import AppLogo from "@/components/ui/AppLogo.vue";
import SocialsList from "./ui/SocialsList.vue";
import FooterNav from "./FooterNav.vue";
import ModalPopupForm from "./ModalPopupForm.vue";
import PopupSuccessfully from "@/components/PopupSuccessfully.vue";
import AppModal from "./ui/AppModal.vue";
import SocialsModal from '@/components/modals/SocialsModal.vue'
import SocialsModalIcon from '@/components/modals/SocialsModalIcon.vue'

// Объявление всех необходимых переменных
const isOpenCallPopupModal = ref(false)
const isPopupSuccessfully = ref(false)
const navFooterList = ref([])
const contacts = ref({})
const socialsList = ref([])
const currentYear = ref(new Date().getFullYear())
const labelList = ref([{ name: "label_1" }, { name: "label_2" }])
const isMobile = ref(false)
const socModal = ref(false)
const reach = ref(null)
// Хук для инициализации медиа-запроса
onMounted(() => {
  matchMedia()
})

// Хук для загрузки данных
onMounted(async () => {
  try {
    const response = await axios.get('/api/getFooterLinks')
    navFooterList.value = response.data.links.map(item => {
      if (item.title === 'Недвижимость') {
        item.links = [...item.links].filter(l => l.link !== '/overseas-estate')
      }
      return item
    })
    contacts.value = response.data.data
    socialsList.value = response.data.data.social
    reach.value = response?.data?.popup

    console.log();

  } catch (error) {
    console.error('Ошибка при загрузке данных:', error)
  }
})

// Функция обработки успеха формы
function formSuccessPopup() {
  isOpenCallPopupModal.value = false
  isPopupSuccessfully.value = true

  setTimeout(() => {
    isPopupSuccessfully.value = false
  }, 4000)
}

// Функция проверки медиа-запроса
function matchMedia() {
  const mediaQuery = window.matchMedia('(max-width: 639px)')
  isMobile.value = mediaQuery.matches
}
</script>

<script>
export default {
  name: "TheFooter",
  components: { TheBasement, AppLogo, SocialsList, AppModal, ModalPopupForm, PopupSuccessfully, FooterNav, SocialsModal, SocialsModalIcon },
};
</script>

<style lang="scss" scoped>
.footer {
  $that: &;

  position: relative;
  background: $black;

  &__inner {
    @extend %container-wide;
    padding-right: 0;

    position: relative;
    z-index: 2;
    // background: linear-gradient(to right,
    //     $color_dark-90 0%,
    //     $color_dark-90 calc(25% + 28px),
    //     $color_dark-70 calc(25% + 28px),
    //     $color_dark-70 100%);

    // @include desktop-l {
    //   background: linear-gradient(to right,
    //       $color_dark-90 0%,
    //       $color_dark-90 calc(25% + (28 / 1800 * 100vw)),
    //       $color_dark-70 calc(25% + (28 / 1800 * 100vw)),
    //       $color_dark-70 100%);
    // }

    // @include laptop {
    //   background: linear-gradient(to right,
    //       $color_dark-90 0%,
    //       $color_dark-90 calc(40% + 7px),
    //       $color_dark-70 calc(40% + 7px),
    //       $color_dark-70 100%);
    // }

    @include phone {
      background: $color_dark-90;
      padding-left: 0;
    }
  }

  &__body {
    display: flex;

    @include phone {
      flex-direction: column;
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 52px;
  }

  &__links {
    flex: 1;
    background: $color-dark_80;
    color: $white;
    padding-top: 86px;
    border-top-left-radius: 90px;
    padding-left: 82px;
    display: flex;
    flex-direction: column;

    @include laptop {
      padding-left: calc(82 / 1280 * 100vw);
      padding-right: calc(120 / 1024 * 100vw);
    }

    @include tablet {
      padding-left: calc(52 / 1024 * 100vw);
      padding-right: 32px;
    }

    @include phone {
      padding-left: 16px;
      padding-right: 16px;
      padding-top: 20px;
      border-top-left-radius: 0;
      order: 1;
    }
  }

  &__contacts {
    flex: 0 0 25%;
    padding-right: calc(136 / 1920 * 100vw);
    padding-top: 60px;

    @media (min-width: 1920px) {
      padding-right: 132px;
      padding-top: 60px;
    }

    @include desktop {
      padding-right: calc(60 / 1535 * 100vw);
    }

    @include laptop {
      flex: 0 0 40%;
      padding-right: calc(112 / 1535 * 100vw);
      padding-top: 26px;
      padding-bottom: 62px;
    }

    @include phone {
      padding-right: 16px;
      padding-left: 16px;
      padding-bottom: 40px;
    }
  }


  &__logo {
    display: block;
  }

  &__address {
    color: $white;
    font-size: 20px;
    line-height: 24px;
    font-style: normal;

    *+* {
      padding-top: 24px;
    }

    @include phone {
      font-size: 14px;
      line-height: 18px;
    }
  }

  &__phone-label,
  &__email-label {
    font-size: 14px;
    color: $color-orange_50;
    padding-right: 4px;
    text-transform: uppercase;
  }

  &__phone,
  &__email {
    display: block;
    color: inherit;
    font-size: inherit;
    line-height: inherit;
    font-style: inherit;
    transition: color 0.25s ease-out;

    &:hover {
      color: $white;
    }
  }

  &__socials-list {
    margin-top: 42px;

    @include phone {
      margin-top: 24px;
    }
  }

  &__nav {
    flex: 1 1 auto;

    @include phone {
      display: none;
    }
  }

  &__label-list {
    flex: none;
    display: flex;
    align-items: center;
    padding-top: 8px;
    gap: 112px;
    margin-top: 92px;

    @include phone {
      gap: 20px;
      padding: 26px 0;
      margin-top: 0;

      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 12px;
      padding: 0;
      margin: 0;
      list-style: none;

      a {
        display: inline-block;
        width: 100%;
        text-align: center;

        svg {
          width: 120px;
        }
      }
    }
  }

  &__label-item {
    svg {
      max-width: 124px;
      max-height: 54px;
      min-width: 102px;
      min-height: 44px;

      @include tablet {
        max-width: calc(124 / 1024 * 100vw);
        max-height: calc(54 / 1024 * 100vw);
      }

      @include phone {
        // max-width: 100%;
        // max-height: 54px;

        max-width: 100%;
        height: auto;
      }
    }

    @include phone {
      // flex: 0 0 75px;
      padding: 12px 0;

      flex: 1 1 calc(30% - 20px);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__basement {
    margin-top: 32px;

    @include phone {
      margin-top: 0;
    }
  }
}
.excursion {
  position: fixed;
  z-index: 1000000;
  bottom: 0px;
  right: 0px;
  opacity: 0.85;
  margin: 17.075vh 3.333vw;
  margin-bottom: 30px;
  width: 96px;
  height: 96px;

  &.social {
    margin-bottom: 156px;
  }
}
.excursion:hover
{
  cursor: pointer;
  opacity: 1.0;
  transform: scale(1.1);
}
@media screen and (max-width: 1920px) {
  .excursion {
    width: 96px;
    height: 96px;
  }
}
@media screen and (max-width: 1366px) {
  .excursion {
    width: 64px;
    height: 64px;
    margin-right: 3.5%;
    margin-bottom: 50px;
  }
}
@media screen and (max-width: 1024px) {
  .excursion {
    width: 64px;
    height: 64px;
    margin-bottom: 50px;
  }
}
@media screen and (max-width: 768px) {
  .excursion {
    width: 48px;
    height: 48px;
    margin-bottom: 35px;

    &.social {
      margin-bottom: 118px;
    }
  }
}
@media screen and (max-width: 320px) {
  .excursion {
    width: 40px;
    height: 40px;
  }
}
</style>
